import axios from 'axios';
import API_BASE_URL from '../utils/apiBase';

export const authAPI = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds timeout for auth operations
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

export const propertyAPI = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // increase to 30 seconds to avoid ECONNABORTED on slow endpoints
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

export const subscriptionAPI = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

export const adminAPI = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to add auth token
const addAuthToken = (config) => {
  const url = String(config?.url || '');
  const isAdminRequest = url.startsWith('/admin/') || url.includes('/admin/');

  const token = isAdminRequest
    ? (localStorage.getItem('admin_token') || localStorage.getItem('token'))
    : (localStorage.getItem('token') || localStorage.getItem('admin_token'));

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// Response interceptor to handle errors
const handleResponseError = (error) => {
  if (error.response?.status === 401) {
    const requestUrl = String(error?.config?.url || '');
    const isAdminRequest = requestUrl.startsWith('/admin/') || requestUrl.includes('/admin/');

    if (isAdminRequest) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/admin/login';
    } else {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
  }
  return Promise.reject(error);
};

// Add interceptors to all API instances
[authAPI, propertyAPI, subscriptionAPI, adminAPI].forEach(api => {
  api.interceptors.request.use(addAuthToken);
  api.interceptors.response.use(
    response => response,
    handleResponseError
  );
});

const apiServices = {
  auth: authAPI,
  property: propertyAPI,
  subscription: subscriptionAPI,
  admin: adminAPI,
};

export default apiServices;
